import Action from './common/action'

export interface Size {
  width: number
  height: number
  sizeRatio: number
}

class SizeSystem {
  onResize = new Action<Size | undefined>()
  isSSR = typeof window === 'undefined'
  size = {
    width: !this.isSSR ? window.innerWidth : 1,
    height: !this.isSSR ? window.innerHeight : 1,
    sizeRatio: 1
  }
  #onResizeDebouncedTimeout: ReturnType<typeof setTimeout> | undefined

  constructor() {
    //render all pixels (highest quality)
    this.size.sizeRatio = !this.isSSR ? window.devicePixelRatio : 1

    //render enough pixels (highest performance)
    //this.size.sizeRatio = 1

    //conditional rendering
    /*if (!this.isSSR && isDesktop) {
      //render less pixels on mobile and ipad
      this.size.sizeRatio = window.devicePixelRatio
    }*/
  }

  async init() {
    if (!this.isSSR) {
      window.addEventListener('resize', this.resizeHandler)
      this.resizeHandler()
    }
  }

  resizeHandler = () => {
    if (this.size.width !== window.innerWidth || this.size.height !== window.innerHeight) {
      this.size.width = window.innerWidth
      this.size.height = window.innerHeight

      if (this.#onResizeDebouncedTimeout) {
        window.clearTimeout(this.#onResizeDebouncedTimeout)
      }

      this.#onResizeDebouncedTimeout = setTimeout(() => {
        if (this.size.width !== window.innerWidth || this.size.height !== window.innerHeight) {
          this.size.width = window.innerWidth
          this.size.height = window.innerHeight
          this.onResize.invoke(this.size)
        }
      }, 500)

      this.onResize.invoke(this.size)
    }
  }

  getSize() {
    return this.size
  }
}

export default new SizeSystem()
